import {
  formatearMonto,
  formatearFechaHora,
  formatearNumeroComprobante,
  nombreOperador,
  ETIQUETAS_METODO,
  ETIQUETAS_MOTIVO,
} from '../utils/formato';
import { IconExito, IconImprimir, IconRechazar } from './icons';

/**
 * Comprobante individual de un cobro, pensado para imprimirse (mismo criterio que el
 * reporte de cierre: ver ".reporte-imprimible" y "@media print" en caja.css). Si el cobro
 * fue anulado, el comprobante lo dice bien claro: el original no se modifica, pero no
 * queda como un comprobante válido.
 */
function ComprobanteCobro({ cobro, operador, registradoAhora = false, onVolver, textoVolver = 'Volver' }) {
  const anulado = Boolean(cobro.anulacion);

  return (
    <section className={`tarjeta reporte-imprimible comprobante ${anulado ? 'comprobante-anulado' : ''}`}>
      {registradoAhora && (
        <p className="mensaje-exito no-imprimir">
          <IconExito size={16} />
          Cobro registrado. Ya podés imprimir el comprobante.
        </p>
      )}

      <div className="reporte-encabezado">
        <img src="/logo-betech.svg" alt="Betech" className="reporte-logo" />
        <div>
          <h2>Comprobante de cobro</h2>
          <p className="reporte-subtitulo">N° {formatearNumeroComprobante(cobro.numero_comprobante)}</p>
        </div>
      </div>

      {anulado && (
        <div className="sello-anulado" role="note">
          <strong>
            <IconRechazar size={18} /> COBRO ANULADO
          </strong>
          <span>
            El {formatearFechaHora(cobro.anulacion.fecha_hora)} por {nombreOperador(cobro.anulacion.operador_id, operador)}.
          </span>
          <span>Motivo: {cobro.anulacion.motivo}</span>
        </div>
      )}

      <div className="resumen-grilla">
        <div>
          <span className="etiqueta">Municipio</span>
          <span>{cobro.municipio_id}</span>
        </div>
        <div>
          <span className="etiqueta">Fecha y hora</span>
          <span>{formatearFechaHora(cobro.fecha_hora)}</span>
        </div>
        <div>
          <span className="etiqueta">Operador</span>
          <span>{nombreOperador(cobro.operador_id, operador)}</span>
        </div>
      </div>

      <div className="resumen-grilla">
        <div>
          <span className="etiqueta">Contribuyente</span>
          <span>{cobro.contribuyente_nombre}</span>
        </div>
        {cobro.contribuyente_dni && (
          <div>
            <span className="etiqueta">DNI</span>
            <span>{cobro.contribuyente_dni}</span>
          </div>
        )}
        <div>
          <span className="etiqueta">Trámite</span>
          <span>{ETIQUETAS_MOTIVO[cobro.motivo] || cobro.motivo}</span>
        </div>
        {cobro.tipo_licencia && (
          <div>
            <span className="etiqueta">Licencia</span>
            <span>
              {cobro.tipo_licencia}
              {cobro.licencia_id_externo ? ` · ${cobro.licencia_id_externo}` : ''}
            </span>
          </div>
        )}
      </div>

      <div className="resumen-grilla">
        <div>
          <span className="etiqueta">Método de pago</span>
          <span>{ETIQUETAS_METODO[cobro.metodo_pago] || cobro.metodo_pago}</span>
        </div>
        {cobro.referencia && (
          <div>
            <span className="etiqueta">Referencia</span>
            <span>{cobro.referencia}</span>
          </div>
        )}
      </div>

      <div className="comprobante-monto">
        <span className="etiqueta">{anulado ? 'Monto (anulado)' : 'Monto cobrado'}</span>
        <span className={anulado ? 'monto-anulado' : ''}>{formatearMonto(cobro.monto)}</span>
      </div>

      <div className="reporte-acciones no-imprimir">
        <button type="button" className="boton boton-secundario boton-con-icono" onClick={() => window.print()}>
          <IconImprimir size={16} />
          Imprimir
        </button>
        {onVolver && (
          <button type="button" className="boton boton-primario" onClick={onVolver}>
            {textoVolver}
          </button>
        )}
      </div>
    </section>
  );
}

export default ComprobanteCobro;
